/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Camera_FrontInputs */

const th_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกกล้องหน้าเป็นหลัก`)
};

const en_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front camera (preferred)`)
};

const ja_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前面カメラを優先`)
};

const zh_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前置摄像头（首选）`)
};

const es_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cámara frontal (preferida)`)
};

const pt_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câmera frontal (preferida)`)
};

const id_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera depan (disukai)`)
};

const fr_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caméra avant (préférée)`)
};

const tl_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera sa harap (mas nais)`)
};

const vi_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy ảnh trước (ưu tiên)`)
};

const ko_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전면 카메라 (선호)`)
};

const de_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontkamera (bevorzugt)`)
};

const ru_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фронтальная камера (предпочтительно)`)
};

const tr_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön kamera (tercihen)`)
};

const it_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotocamera frontale (preferita)`)
};

const pl_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera przednia (preferowana)`)
};

const uk_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фронтальна камера (бажано)`)
};

const hi_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामने का कैमरा (वरीयता)`)
};

const ar_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكاميرا الأمامية (مفضّلة)`)
};

const ms_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera hadapan (diutamakan)`)
};

const bn_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সামনের ক্যামেরা (পছন্দের)`)
};

const zh_tw2_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前置相機（偏好）`)
};

const zh_hk2_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前置相機（偏好）`)
};

const ur_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگلا کیمرا (ترجیحی)`)
};

const fa_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوربین جلو (ترجیحی)`)
};

const sw_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera ya mbele (inapendelewa)`)
};

const nl_video_camera_front = /** @type {(inputs: Video_Camera_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera aan de voorkant (voorkeur)`)
};

/**
* | output |
* | --- |
* | "Front camera (preferred)" |
*
* @param {Video_Camera_FrontInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera_front = /** @type {((inputs?: Video_Camera_FrontInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Camera_FrontInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera_front(inputs)
	if (locale === "ja") return ja_video_camera_front(inputs)
	if (locale === "zh") return zh_video_camera_front(inputs)
	if (locale === "es") return es_video_camera_front(inputs)
	if (locale === "pt") return pt_video_camera_front(inputs)
	if (locale === "id") return id_video_camera_front(inputs)
	if (locale === "fr") return fr_video_camera_front(inputs)
	if (locale === "tl") return tl_video_camera_front(inputs)
	if (locale === "vi") return vi_video_camera_front(inputs)
	if (locale === "ko") return ko_video_camera_front(inputs)
	if (locale === "de") return de_video_camera_front(inputs)
	if (locale === "ru") return ru_video_camera_front(inputs)
	if (locale === "tr") return tr_video_camera_front(inputs)
	if (locale === "it") return it_video_camera_front(inputs)
	if (locale === "pl") return pl_video_camera_front(inputs)
	if (locale === "uk") return uk_video_camera_front(inputs)
	if (locale === "hi") return hi_video_camera_front(inputs)
	if (locale === "ar") return ar_video_camera_front(inputs)
	if (locale === "ms") return ms_video_camera_front(inputs)
	if (locale === "bn") return bn_video_camera_front(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera_front(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera_front(inputs)
	if (locale === "ur") return ur_video_camera_front(inputs)
	if (locale === "fa") return fa_video_camera_front(inputs)
	if (locale === "sw") return sw_video_camera_front(inputs)
	if (locale === "nl") return nl_video_camera_front(inputs)
	return en_video_camera_front(inputs)
});